// extracted by mini-css-extract-plugin
module.exports = {"donutLabels":"Charts_donutLabels__mSpB1","label":"Charts_label__2Ak89"};